/**
 * Shared dashboard period labels for axis ticks vs tooltips (WSRADM-0043).
 */
import { formatMonthLabel } from '@/api/reports/format';

/** Bare day-of-month (daily) or "Sep 2026" (monthly) — axis ticks. */
export function periodTickLabel(period: string, daily: boolean, locale: string): string {
  if (daily) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(period);
    return match ? String(Number(match[3])) : period;
  }
  return formatMonthLabel(period, locale);
}

/** "Monday, Jul 4, 2026" (daily) or "Sep 2026" (monthly) — tooltips. */
export function periodTooltipLabel(period: string, daily: boolean, locale: string): string {
  if (daily) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(period);
    if (!match) return period;
    const y = Number(match[1]);
    const m = Number(match[2]);
    const d = Number(match[3]);
    return new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(new Date(y, m - 1, d));
  }
  return formatMonthLabel(period, locale);
}
